'use strict';

var novicell = novicell || {};

novicell.helper = novicell.helper || new function () {

    this.buttonsWithLink = function () {
        var buttonsWithLink = document.querySelectorAll('a > .button');
        if (!buttonsWithLink || buttonsWithLink.length <= 0) {
            return;
        }

        for (let i = 0; i < buttonsWithLink.length; i++) {
            const currentLink = buttonsWithLink[i];
            const parent = currentLink.parentNode;

            parent.classList.add('button-with-link');
        }
    };

    this.findAncestor = function (el, cls) {
        if (el == null) {
            return;
        }
        while ((el = el.parentElement) && !el.classList.contains(cls)) {
            return el;
        }
    };

    this.toggleClass = function (el, className) {
        if (el.classList) {
            el.classList.toggle(className);
        } else {
            var classes = el.className.split(' ');
            var existingIndex = classes.indexOf(className);
            
            if (existingIndex >= 0) {
                classes.splice(existingIndex, 1);
            } else {
                classes.push(className);
            }
            
            el.className = classes.join(' ');
        }
    };

    this.hasClass = function (el, className) {
        if (el.classList.contains(className)) {
            return true;
        } else {
            return false;
        }
    };

    this.isVisible = function (element) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || html.clientHeight) &&
            rect.right <= (window.innerWidth || html.clientWidth)
        );
    };

};